<div *transloco="let trans; read: 'checkForUpdate'" class="px-3 h-fit">
  <div>
    <span class="mx-2 page-title text-md sm:text-lg md:text-xl line-clamp-2 version-title">
      {{ trans('checkUpdate.title') }}
    </span>
    <br />
    <div class="px-2 py-5" mat-dialog-content>
      <span class="text-sm sm:text-md">
        {{ trans('checkUpdate.description') }}
      </span>
    </div>
  </div>
  <div class="flex justify-center grid grow grid-cols-1 md:grid-cols-2 gap-y-2">
    <button
      class="text-center bg-blue text-white hover:font-medium hover:text-white py-2 mx-2 px-4 rounded text-xs sm:text-sm shadow-sm inline-flex m-auto transition duration-300 ease-in-out col-span-1"
      (click)="onUpdateVersionNow()"
      data-qa="check-for-update-update"
    >
      <span class="m-auto">{{ trans('checkUpdate.refresh') }}</span>
    </button>
    <button
      class="text-dark bg-transparent hover:font-medium py-2 mx-2 px-2 rounded text-xs sm:text-sm shadow-sm inline-flex m-auto transition duration-300 ease-in-out col-span-1"
      (click)="onStartDelayTimer()"
      data-qa="check-for-update-timer"
    >
      <span class="m-auto">{{ trans('checkUpdate.later') }}</span>
    </button>
  </div>
</div>
